import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isEmpty, isUndefined } from 'lodash';

/**
 * Mutation: SaveAlertConfiguration
 *
 * Saves a single alert with the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const SaveAlertConfiguration = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': '/alerts/configuration',
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    if (!isUndefined(thePayload?.configurationId) && !isEmpty(thePayload?.configurationId)) {
      requestArgs.method = 'PUT';
      requestArgs.headers['x-api-endpoint'] += `/${thePayload?.configurationId}`;
    }

    Object.keys(thePayload).forEach((key) => {
      const value = thePayload?.[key];

      if (key === 'configurationId' && isEmpty(value)) {
        return;
      }

      requestArgs.data[key] = value;
    });

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Alert/api/requests/mutations/SaveAlertConfiguration/SaveAlertConfiguration.js -> SaveAlertConfiguration()',
      false,
      error
    );

    throw error;
  }
};
